module.exports = __webpack_public_path__ + "static/media/NikeN7-NSWToronto.9e7394eb.jpg";